import { Injectable, inject } from '@angular/core';

import { LocalStoreService, OnAppInit } from '@frontend/vanilla/core';
import { LaunchDarklyService } from '@frontend/vanilla/features/launch-darkly';
import { LDEvaluationDetail } from 'launchdarkly-js-client-sdk';
import { Observable, forkJoin, take } from 'rxjs';

import { LDFeatureFlags, LD_FEATURE_FLAG_STORAGE_KEY } from './flags';

@Injectable({ providedIn: 'root' })
export class LaunchDarklyFlagManagerService implements OnAppInit {
    private localStoreService = inject(LocalStoreService);
    private launchDarklyService = inject(LaunchDarklyService);
    private featureFlagKeys$: Record<string, Observable<string | boolean | undefined>> = {
        [LDFeatureFlags.DisplayMode]: this.launchDarklyService.getFlagOnly$(LDFeatureFlags.DisplayMode).pipe(take(1)),
        [LDFeatureFlags.ReuseSelections]: this.launchDarklyService.getFlagOnly$(LDFeatureFlags.ReuseSelections).pipe(take(1)),
        [LDFeatureFlags.ESoccerInAZMenu]: this.launchDarklyService.getFlagOnly$(LDFeatureFlags.ESoccerInAZMenu).pipe(take(1)),
        [LDFeatureFlags.EnableLiveAlerts]: this.launchDarklyService.getFlagOnly$(LDFeatureFlags.EnableLiveAlerts).pipe(take(1)),
    };

    onAppInit() {
        forkJoin(this.featureFlagKeys$).subscribe((featureFlags) => {
            this.localStoreService.set(LD_FEATURE_FLAG_STORAGE_KEY, featureFlags);
        });
    }

    getFeatureFlag = (flagName: string) =>
        (this.localStoreService.get(LD_FEATURE_FLAG_STORAGE_KEY) as Record<string, string | boolean | undefined>)?.[flagName];

    activateExperiment$(key: string): Observable<LDEvaluationDetail> {
        return this.launchDarklyService.getFeatureFlagValueWithEvaluationReasons$(key);
    }

    isFlagInContext(flag: LDFeatureFlags) {
        const ldCurrentFlags = Object.keys(this.launchDarklyService.client?.allFlags() ?? {});
        return ldCurrentFlags.includes(flag);
    }

    isFlagInLocalStorage(flag: LDFeatureFlags) {
        return this.getFeatureFlag(flag) !== undefined;
    }
}
